import { ChangeDetectionStrategy, Component, effect, inject, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { COMMON_IMPORTS } from '../../../../Shared/common-imports';
import { AvContentContainerComponent } from '../../../../Shared/Components/av-content-container/av-content-container.component';
import { AvSpinComponent } from '../../../../Shared/Components/av-spin/av-spin.component';
import { waitState } from '../../../../Shared/Services/wait-state.util';
import { DemandReferenceFacade } from '../../../Facades/demand-reference.facade';
import { DEMAND_REFERENCE_PARAM } from '../../../Consts/demand-reference-route.const';

@Component({
  selector: 'app-demand-reference',
  standalone: true,
  imports: [COMMON_IMPORTS, AvContentContainerComponent, AvSpinComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './demand-reference.component.html',
})
export class DemandReferenceComponent implements OnDestroy {
  private readonly _route = inject(ActivatedRoute);
  private readonly _router = inject(Router);
  private readonly _facade = inject(DemandReferenceFacade);

  protected readonly wait = waitState(this._facade.resolving);

  constructor() {
    this._facade.resolve(this._route.snapshot.paramMap.get(DEMAND_REFERENCE_PARAM) ?? '');
    this._registerLandingRedirect();
  }

  ngOnDestroy(): void {
    this._facade.reset();
  }

  private _registerLandingRedirect(): void {
    effect(() => {
      const landing = this._facade.landing();
      if (landing) {
        void this._router.navigate(landing, { replaceUrl: true });
      }
    });
  }
}
